import React from 'react';
import "../styles/SlotDetails.css";

const SlotCard = ({ slotName, startTime, endTime, totalTickets, prices }) => {
    return (
        <div className="slot-card">
            <h2>{slotName}</h2>
            <p>{`${startTime} to ${endTime}`}</p>
            <p>{`Total Tickets: ${totalTickets}/day`}</p>
            <p>
                {`Adult: ₹${prices.adult}`}
                <br />
                {`Children*: ₹${prices.children}`}
                <br />
                {`Video Camera: ₹${prices.videoCamera}`}

                <br />
                <br />
                <span style={{ fontSize: "0.75rem", }}>
                    <i> *Children must be aged 5-12 years</i>
                </span>
            </p>
        </div>
    );
};

const SlotDetails = () => {
    return (
        <div id='details'>
            <h1>Slots & Pricing</h1>
            <div className="slot-details">
                <SlotCard
                    slotName="Early Access"
                    startTime="7:00 AM"
                    endTime="8:30 AM"
                    totalTickets={200}
                    prices={{ adult: 100, children: 50, videoCamera: 1000 }}
                />
                <SlotCard
                    slotName="Morning Slot"
                    startTime="9:00 AM"
                    endTime="12:00 PM"
                    totalTickets={400}
                    prices={{ adult: 50, children: 30, videoCamera: 1000 }}
                />
                <SlotCard
                    slotName="Afternoon Slot"
                    startTime="12:30 PM"
                    endTime="3:30 PM"
                    totalTickets={400}
                    prices={{ adult: 50, children: 30, videoCamera: 1000 }}
                />
            </div>
        </div>
    );
};

export default SlotDetails;
